import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { DesignPlainContainer } from "@/components/features/design/plain";

import { useConfirmParams } from "./hooks";

export const DesignPlainDefaultPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="プレーンの設定" url={generatePath(PATHS.HOTEL.RESERVATION_PAGE.BASE, { hotelID })}>
			<DesignPlainContainer hotelID={hotelID} />
		</PageMeta>
	);
};
